export default __webpack_public_path__ + "static/media/PitcherAngle-RightHandBatter.dd9bc6be.png";